import script from "./luPid.vue?vue&type=script&setup=true&lang=ts"
export * from "./luPid.vue?vue&type=script&setup=true&lang=ts"

import "./luPid.vue?vue&type=style&index=0&id=081a9dec&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081a9dec"]])

export default __exports__